export default {
  pageTitle: 'Recharge packs',
  guide: 'Recharge packs are for company users to add extra AI retouching, cloud storage, SMS, and name-card quotas beyond the membership plan. Each resource has multiple tiers; you can buy again after the credit runs out.',
  tabMine: 'My packs',
  tabCatalog: 'Recharge packs',
  tabRecords: 'Recharge history',
  listed: 'Listed',
  packageTiers: '{n} tiers',
  statTiers: 'Tiers',
  statTiersValue: '{n} tiers',
  statMinPrice: 'From',
  statMaxPrice: 'Up to',
  validityRange: 'Valid {min}-{max} days',
  validityDays: '{n} days',
  priceRange: '{min}--{max}',
  recharge: 'Recharge',
  empty: 'No recharge packs available',
  unlimited: 'Unlimited',
  masterExempt: 'This is the platform company and does not purchase recharge packs',
  buySuccess: 'Credit added',
  payTitle: 'Pay for recharge',
  payNow: 'Pay ¥{amount} now',
  payMethod: 'Payment method',
  payWechat: 'WeChat Pay',
  payAlipay: 'Alipay',
  payTransfer: 'Bank transfer',
  payScanTip: 'Scan with WeChat to pay',
  payNotice: 'Credits are added as soon as payment succeeds. This pack is extra capacity outside the membership plan. Request invoices from order history after paying.',
  payFailed: 'Could not start payment',
  payNoCodeUrl: 'No payment QR code',
  payCancelled: 'Order cancelled. Please place a new order.',
  payCancel: 'Cancel',
  paySuccess: 'Paid',
  payCountdown: '{time} left',
  mineTitle: 'My packs',
  mineCount: '{n} active packs',
  mineGuide: 'These are resource packs credited from Recharge packs. Check remaining credit and expiry. To add more, go to Recharge packs.',
  validUntilLabel: 'Valid until',
  mineEmpty: 'No active recharge packs',
  orderNo: 'Order',
  used: 'Used',
  remaining: 'Left',
  validUntil: 'Valid until {date}',
  recordsTitle: 'Recharge history',
  recordsTotal: 'Total {amount}',
  recordsCardTitle: 'My recharge records',
  colOrderId: 'Order no.',
  colContent: 'Item',
  colAmount: 'Amount',
  colPayMethod: 'Payment',
  colChargedAt: 'Time',
  colStatus: 'Status',
  colUserName: 'Account',
  colVerification: 'Verification',
  verificationEnterprise: 'Enterprise',
  verificationPersonal: 'Individual',
  verificationNone: 'Unverified',
  adminRecordsCardTitle: 'Recharge records',
  payEnterpriseTransfer: 'Corporate transfer',
  payFree: 'Free',
  statusPaid: 'Credited',
  statusCancelled: 'Cancelled',
  statusPending: 'Unpaid'
}
